import { useCanvasOperations } from '../../hooks';
import { useDesignerStore } from '../../stores';
import type { AlignmentType } from '../../types/canvas';
import { t } from '../../i18n';
import styles from './PropertiesPanel.module.css';

export const AlignmentTools = () => {
  const { activeObject } = useDesignerStore();
  const { alignObject } = useCanvasOperations();

  // Don't show if no object selected or if system object
  if (!activeObject || activeObject.isGuide || activeObject.isMockup || activeObject.isBaseImage || activeObject.isMaskOverlay) {
    return null;
  }

  const handleAlign = (alignment: AlignmentType) => {
    alignObject(alignment);
  };

  return (
    <div className={styles.panel}>
      <div className={styles.panelTitle}>{t('design.align.title', 'Alignment')}</div>

      <div className={styles.propertyGroup}>
        <label className={styles.label}>{t('design.align.horizontal', 'Horizontal')}</label>
        <div className={styles.buttonGroup}>
          <button
            className={styles.styleButton}
            onClick={() => handleAlign('left')}
            title={t('design.align.left', 'Align Left')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="4" y1="4" x2="4" y2="20" />
              <rect x="8" y="6" width="12" height="4" />
              <rect x="8" y="14" width="8" height="4" />
            </svg>
          </button>
          <button
            className={styles.styleButton}
            onClick={() => handleAlign('center')}
            title={t('design.align.center', 'Align Center')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="4" x2="12" y2="20" />
              <rect x="4" y="6" width="16" height="4" />
              <rect x="6" y="14" width="12" height="4" />
            </svg>
          </button>
          <button
            className={styles.styleButton}
            onClick={() => handleAlign('right')}
            title={t('design.align.right', 'Align Right')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="20" y1="4" x2="20" y2="20" />
              <rect x="4" y="6" width="12" height="4" />
              <rect x="8" y="14" width="8" height="4" />
            </svg>
          </button>
        </div>
      </div>

      <div className={styles.propertyGroup}>
        <label className={styles.label}>{t('design.align.vertical', 'Vertical')}</label>
        <div className={styles.buttonGroup}>
          <button
            className={styles.styleButton}
            onClick={() => handleAlign('top')}
            title={t('design.align.top', 'Align Top')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="4" y1="4" x2="20" y2="4" />
              <rect x="6" y="8" width="4" height="12" />
              <rect x="14" y="8" width="4" height="8" />
            </svg>
          </button>
          <button
            className={styles.styleButton}
            onClick={() => handleAlign('middle')}
            title={t('design.align.middle', 'Align Middle')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="4" y1="12" x2="20" y2="12" />
              <rect x="6" y="4" width="4" height="16" />
              <rect x="14" y="6" width="4" height="12" />
            </svg>
          </button>
          <button
            className={styles.styleButton}
            onClick={() => handleAlign('bottom')}
            title={t('design.align.bottom', 'Align Bottom')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="4" y1="20" x2="20" y2="20" />
              <rect x="6" y="4" width="4" height="12" />
              <rect x="14" y="8" width="4" height="8" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlignmentTools;
